import { Box, Theme, Typography, useMediaQuery } from '@material-ui/core'
import Image from 'components/image'
import AlertDialog, { AlertDialogProps } from 'baby-ui/compounds/AlertDialog'
import useStyles from './FreeGiftModal.styles'

const bulletPoints = [
  'Set of 120, self-standing bags',
  'An indicator to ensure a safe serving temperature for baby',
  'Perfect for storing your liquid gold in fridge or freezer',
]

export type FreeGiftModal = Pick<AlertDialogProps, 'open' | 'onClose'>

const FreeGiftModal = ({ open, onClose }: FreeGiftModal) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const classes = useStyles()

  return (
    <AlertDialog
      closeOnBackdropClick
      disableCloseButtonAllowance
      open={open}
      title={
        <Box textAlign="center">
          <Image
            height={isMobile ? 236 : 257}
            src="//images.babylist.com/image/upload/v1695156551/DME/Frame_1103.png"
            width={isMobile ? 236 : 257}
          />
        </Box>
      }
      onClose={onClose}
    >
      <div className={classes.marginTopAdjustment}>
        <Typography className={classes.modalHeadline} variant="h6">
          Get a FREE gift with your order!
        </Typography>
        <Typography color="textPrimary">
          Receive free Momcozy breast milk storage bags:
        </Typography>
        <ul className={classes.modalListWrapper}>
          {bulletPoints.map((text) => (
            <Typography color="textPrimary" component="li" key={text}>
              {text}
            </Typography>
          ))}
        </ul>
        <div className={classes.modalDisclaimer}>
          <Typography color="textPrimary" variant="caption">
            This free gift is a limited of time offer and while supplies last.
            More disclaimer text goes here that is important to know and so we
            don't get legally screwed. Yay.
          </Typography>
        </div>
      </div>
    </AlertDialog>
  )
}
export default FreeGiftModal
